module.exports = {
    NoDatatype: new Error('No data type (B, BS, N, NS, S, SS).'),
    NoData: new Error('No data')
};
